import classNames from 'classnames';
import { ArticleHeader } from 'components/2-molecules/Article';
import { DocumentItem, DocumentItemProps } from 'components/2-molecules/DocumentItem';
import { Container, ContainerWidth } from 'components/4-habitats/Container';
import { TopArea, TopAreaProps } from 'components/4-habitats/TopArea';
import styles from './DocumentPage.module.scss';
export interface DocumentPageProps {
	aside: React.ReactNode;
	additionalTop?: TopAreaProps['additional'];
	additionalPageContent?: React.ReactNode;
	heading: string;
	documentItems: DocumentItemProps[];
	teaser?: string;
	topBanner?: React.ReactNode;
	pageWidth?: ContainerWidth;
}

export const DocumentPage: React.FC<DocumentPageProps> = ({
	aside,
	additionalTop,
	additionalPageContent,
	heading,
	documentItems,
	teaser,
	topBanner,
	pageWidth = 'Medium',
}) => {
	return (
		<div className={styles.DocumentPage}>
			<TopArea additional={additionalTop} topBanner={topBanner} />
			<Container className={classNames(styles.DocumentPage_container, 'u-aside')} width={pageWidth} padded>
				<article>
					{additionalPageContent}
					<div className={styles.DocumentPage_content}>
						{heading && <ArticleHeader heading={heading} teaser={teaser} pageWidth={pageWidth} />}
						{documentItems.map((item, index) => {
							return item?.value && item?.label && <DocumentItem key={index} {...item} uid={index} />;
						})}
					</div>
				</article>
				{aside}
			</Container>
		</div>
	);
};
